import Ajax from "Utils/ajax";
export const getReleaseNotesDetails = (data) => Ajax.post('hr/getReleaseNotesDetails',data);